<template lang="pug">
.countdown-btn
  .wrapper(@click="onComplete") {{copy}}({{local_countdown}})
  
</template>
<script>
import { mapState } from 'vuex'
import gsap from 'gsap'
export default {
  name: 'CountdownBtn',
  props: {
    countdown: {
      default: 3,
    },
    copy: {},
  },
  data() {
    return {
      local_countdown: 3,
      interval: null,
    }
  },
  computed: {
    ...mapState('app', ['router']),
  },
  methods: {
    onComplete() {
      console.log('complete')
      if (this.interval) clearInterval(this.interval)
      if (this.$route.path !== this.router.back)
        this.$router.replace(this.router.back)
    },
  },
  mounted() {
    this.local_countdown = this.countdown
    this.interval = setInterval(() => {
      if (this.local_countdown === 0) {
        clearInterval(this.interval)
        this.onComplete()
        return
      }
      this.local_countdown--
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.countdown-btn
  position: fixed
  bottom: pxToRem(88)
  left: 0
  width: 100%
  height: pxToRem(98)
  +flex-center
  .wrapper
    width: pxToRem(702)
    height: pxToRem(98)
    background-image: linear-gradient(135deg, #168BFF 0%, #1664FF 100%)
    box-shadow: pxToRem(2) pxToRem(13) pxToRem(23) pxToRem(-10) rgba(22,139,255,0.60)
    border-radius: pxToRem(8)
    font-size: pxToRem(36)
    line-height: pxToRem(98)
    color: #ffffff
    text-align: center
</style>
